import React from 'react';
import { Schema } from './components/Schema';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { AEOAnswerHub } from './components/AEOAnswerHub';
import { ServiceSelector } from './components/ServiceSelector';
import { MeetMike } from './components/MeetMike';
import { Reviews } from './components/Reviews';
import { PricingCalculator } from './components/PricingCalculator';
import { WhyLangler } from './components/WhyLangler';
import { Process } from './components/Process';
import { ComparisonTable } from './components/ComparisonTable';
import { InstallGallery } from './components/InstallGallery';
import { Brands } from './components/Brands';
import { SmartZone } from './components/SmartZone';
import { Commercial } from './components/Commercial';
import { SuburbsMap } from './components/SuburbsMap';
import { FAQ } from './components/FAQ';
import { QuoteForm } from './components/QuoteForm';
import { TopicalAuthority } from './components/TopicalAuthority';
import { Footer } from './components/Footer';
import { MobileStickyCTA } from './components/MobileStickyCTA';
import { ScrollQuoteBar } from './components/ScrollQuoteBar';
export function App() {
  return <div className="min-h-screen flex flex-col bg-cream text-ink-900 font-sans" data-id="element-0">
      <a href="#main" className="skip-link" data-id="element-1">
        Skip to content
      </a>
      <Schema data-id="element-2" />
      <Header data-id="element-3" />
      <ScrollQuoteBar data-id="element-4" />

      <main id="main" className="flex-grow pb-20 lg:pb-0" data-id="element-5">
        {/* Hero with embedded form: cold to warm intent capture */}
        <Hero data-id="element-6" />

        {/* Live credibility numbers (no fabricated counts) */}
        <TrustStrip data-id="element-7" />

        {/* AEO Answer Hub: AI Overviews / ChatGPT / Perplexity extraction surface */}
        <AEOAnswerHub data-id="element-8" />

        {/* Service router: which path are you on */}
        <ServiceSelector data-id="element-9" />

        {/* Meet Mike: owner trust early. Who am I hiring */}
        <MeetMike data-id="element-10" />

        {/* Social proof: 6 Google reviews */}
        <Reviews data-id="element-11" />

        {/* Pricing transparency: kills cost anxiety */}
        <PricingCalculator data-id="element-12" />

        {/* Six differentiators in 2x3 grid */}
        <WhyLangler data-id="element-13" />

        {/* Four step process timeline */}
        <Process data-id="element-14" />

        {/* Honest comparison vs wholesalers and discount installers */}
        <ComparisonTable data-id="element-15" />

        {/* Real Perth install gallery */}
        <InstallGallery data-id="element-16" />

        {/* Brand authority strip */}
        <Brands data-id="element-17" />

        {/* Smart Zone iZone cross sell */}
        <SmartZone data-id="element-18" />

        {/* Commercial HVAC segment */}
        <Commercial data-id="element-19" />

        {/* Local suburb coverage */}
        <SuburbsMap data-id="element-20" />

        {/* FAQ accordion: final objection killer */}
        <FAQ data-id="element-21" />

        {/* Final commitment form with testimonial sidebar */}
        <QuoteForm data-id="element-22" />

        {/* Topical authority hub: internal link surface for SEO + GEO */}
        <TopicalAuthority data-id="element-23" />
      </main>

      <Footer data-id="element-24" />
      <MobileStickyCTA data-id="element-25" />
    </div>;
}